<template >
  <div class="head-wrapper" :style="{height: `${height/100}rem`}">
    <img v-if="showBack" @click="goBack" src="../assets/back.png">
    <div v-else style="width: 30px; height: 100%"></div>
    <p class="title"> {{title}}</p>
    <img class="search-icon" v-if="!nosearch" src="@/assets/search.png" @click="$router.push('/search.html')">
    <div v-else style="width: 30px; height: 100%"></div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import config from '@/config'
import moment from 'moment'

export default {
  props: {
    height: {
      type: Number,
      default: 30
    },
    showBack: {
      type: Boolean,
      default: true
    },
    nosearch: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    },
    back: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      nowTime: moment().format('MM-DD HH:mm:ss')
    }
  },
  computed: {
    ...mapState(['status', 'code', 'market', 'stockname'])
  },
  created() {
    window.onscroll = null
  },
  methods: {
    goBack() {
      if (this.back) {
        this.$router.push({
          path: `/${this.market}/${this.code}.html`,
        })
      } else {
        this.$router.back()
      }
    },
  },
  filters: {
    getStatus(type) {
      return config.marketStatus[type]
    }
  }
}
</script>

<style lang="stylus" scoped>
div
  box-sizing border-box
.head-wrapper
  display flex
  justify-content space-between
  align-items center
  padding 0 .15rem
  height .3rem
  position fixed
  width 100%
  top: 0
  text-align: center
  background linear-gradient(#FF2020, #F43737)
  color: #FFFFFF
  z-index 9999

.title
  font-size: .17rem

.sub-title
  font-size: .12rem
  margin-top .04rem
img 
  // position absolute
  width 10px
  height 16px
  // left .15rem
  // bottom: .11rem
  size convert
.search-icon
  width 30px
  height 30px
  size convert
</style>
